export class ArchivComponenteFile {
  filesize: number;
  filecontentAsBase64: string;

  constructor(filesize: number, data: string) {
    this.filesize = filesize;
    this.filecontentAsBase64 = data;
  }
}